<form [formGroup]="identityForm" (ngSubmit)="submitForm()" class="flex justify-center">
  <mat-card>
    <section>
      <mat-form-field>
        <mat-label>Fonction</mat-label>
        <input matInput placeholder="Saisir une fonction" formControlName="function" />
        <mat-error *ngIf="function.hasError('required')">Vous devez saisir une fonction</mat-error>
      </mat-form-field>
    </section>
    <mat-card-actions class="center-actions">
      <button mat-raised-button type="submit">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>